import {
    BRANDS_EDIT_BRAND_OPEN_MODAL,
    BRANDS_EDIT_BRAND_CLOSE_MODAL,
    BRANDS_EDIT_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_RESULT,
    BRANDS_EDIT_BRAND_GET_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_GET_BRAND_RESULT,
    BRANDS_EDIT_NEW_BRAND_REQUEST,
    BRANDS_EDIT_NEW_BRAND_RESULT
} from 'Redux/actionTypes';

export const brandsEditBrandOpenModal = (brandId) => ({
    type: BRANDS_EDIT_BRAND_OPEN_MODAL,
    payload: brandId
})

export const brandsEditBrandCloseModal = () => ({
    type: BRANDS_EDIT_BRAND_CLOSE_MODAL
})

export const brandsEditBrandRequest = (data) => ({
    type: BRANDS_EDIT_BRAND_REQUEST,
    payload: data
})

export const brandsEditBrandResult = (result) => ({
    type: BRANDS_EDIT_BRAND_RESULT,
    payload: result
})

export const brandsGetBrandRequest = (id) => ({
    type: BRANDS_EDIT_BRAND_GET_BRAND_REQUEST,
    payload: id
})

export const brandsGetBrandResult = (result) => ({
    type: BRANDS_EDIT_BRAND_GET_BRAND_RESULT,
    payload: result
})

export const brandsEditNewBrandRequest = (data) => ({
    type: BRANDS_EDIT_NEW_BRAND_REQUEST,
    payload: data
})
export const brandsEditNewBrandResult = (result) => ({
    type: BRANDS_EDIT_NEW_BRAND_RESULT,
    payload: result
})
